import React from 'react';
import ReactDOM from 'react-dom';

const key = '_apiInstancePromise';

/**
 * 获取组件实例
 * @param {React.Component} Component 组件
 */
export function getInstance(Component) {
  return Component[key];
}

/**
 * 将组件挂载到 ApiContainer（DOM），每个组件只会挂载一次
 * @param {React.Component} Component React组件
 * @param {object} props Props
 * @param {object} container 挂载的目标节点
 */
export function render(Component, props = {}, container = null) {
  if (Component[key]) {
    return Component[key];
  }
  // eslint-disable-next-line
  Component[key] = new Promise((resolve, reject) => {

    ReactDOM.render(
      <Component
        {...props}
        ref={(node) => {
          if (node) {
            resolve(node);
          } else {
            reject(new Error('ApiContainer挂载失败'));
          }

          props.ref && props.ref(node);
        }}
      />,
      container || createApiContainer()
    );
  });

  return Component[key];
}


export function createApiContainer() {
  const node = document.createElement('div');
  node.className = 'component-api-container';
  document.body.appendChild(node);

  return node;
}
